import { Icon } from '@iconify/react/dist/iconify.js'
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  useDisclosure,
  Chip,
  Input,
} from "@nextui-org/react"
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { GetCarModelOptions } from '../../services/TicketService';
import AppUserProfile, { UserType } from '../../assets/js/AppUserProfile';


const userRole = AppUserProfile.getData()["whoami"];
let setBlankActual_Amount =
  userRole === UserType.DEALER_BYD || userRole === UserType.DEALER_DENZA
    ? null
    : 0;


const TargetTable = forwardRef((prop, ref) => {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const [carModelOptions, setCarModelOptions] = useState([]);
  const [selectedModelsModal, setSelectedModelsModal] = useState([]);
  const [selectedModels, setSelectedModels] = useState([])
  const [sumExpectedCustomer, setSumExpectedCustomer] = useState(0)
  const [sumExpectedReserved, setSumExpectedReserved] = useState(0)
  const [sumActualCustomer, setSumActualCustomer] = useState(0)
  const [sumActualReserved, setSumActualReserved] = useState(0)

  useEffect(() => {
    const loadOptions = async () => {
      const res = await GetCarModelOptions()
      setCarModelOptions(res?.data.car_model_options)
    }
    if (prop.initialData) {
      const initModels = prop.initialData?.map((model) =>{
        return {
          id: model.id,
          name: model.name,
          expectedCustomerAmount : model.expectedCustomerAmount ?? 0,
          expectedReservedAmount : model.expectedReservedAmount ?? 0,
          actualCustomerAmount :  model.actualCustomerAmount ?? setBlankActual_Amount,
          actualReservedAmount :  model.actualReservedAmount ?? setBlankActual_Amount,
        }
      })
      setSelectedModels(initModels)
      setSumExpectedCustomer(initModels.reduce((accumulator, model) => {
        return accumulator + model.expectedCustomerAmount
      }, 0))
      setSumExpectedReserved(initModels.reduce((accumulator, model) => {
        return accumulator + model.expectedReservedAmount
      }, 0))
      setSumActualCustomer(initModels.reduce((accumulator, model) => {
        return accumulator + model.actualCustomerAmount
      }, 0))
      setSumActualReserved(initModels.reduce((accumulator, model) => {
        return accumulator + model.actualReservedAmount
      }, 0))
    }
    loadOptions();
  }, [])

  const onClickChip = (option) => {
    const index = selectedModelsModal.indexOf(option)
    setSelectedModelsModal(index < 0 ? [...selectedModelsModal, option] : selectedModelsModal.filter((_, i) => i !== index))
  }

  const selectModelFromModal = () => {
    const newSelectedModels = selectedModelsModal.map((model) => {
      const insertModel = selectedModels.find((selectedModel) => selectedModel.name === model)
      return insertModel ? insertModel : {
        name: model,
        expectedCustomerAmount: 1,
        expectedReservedAmount: 1,
      }
    })
    setSelectedModels(newSelectedModels)
    prop?.submitData(newSelectedModels)
    setSumExpectedCustomer(newSelectedModels.reduce((accumulator, model) => {
      return accumulator + model.expectedCustomerAmount
    }, 0))
    setSumExpectedReserved(newSelectedModels.reduce((accumulator, model) => {
      return accumulator + model.expectedReservedAmount
    }, 0))
  }

  const deselectModel = (model) => {
    const newSelectedModels = selectedModels.filter(select => model.name !== select.name)
    setSelectedModels(newSelectedModels)
    prop?.submitData(newSelectedModels)
    setSumExpectedCustomer(newSelectedModels.reduce((accumulator, model) => {
      return accumulator + model.expectedCustomerAmount
    }, 0))
    setSumExpectedReserved(newSelectedModels.reduce((accumulator, model) => {
      return accumulator + model.expectedReservedAmount
    }, 0))
  }

  useImperativeHandle(ref, () => ({
    isError: () => {
      let isError = false
      selectedModels.forEach((model) => {
        if (model.expectedCustomerAmount < 1 || model.expectedReservedAmount < 1) {
          isError = true
        }
        if (prop.isEditable && (model.actualCustomerAmount < 0 || model.actualReservedAmount < 0)) {
          isError = true
        }
      })
      return isError
    },
  }))

  return (
    <div className="flex flex-col gap-y-2">
      <div className="flex justify-between items-center">
        <div className="text-lg font-semibold">แผนงานยอดขาย</div>
        {
          prop.isCreate &&
          <Button
            variant="flat"
            className="bg-gray-600 text-white"
            startContent={<Icon color='#ffffff' icon="majesticons:plus" />}
            onPress={() => {
              setSelectedModelsModal(selectedModels.map((model) => model.name))
              onOpen()
            }}
          >
            เพิ่มรุ่น
          </Button>
        }
        <Modal isOpen={isOpen} size="sm" scrollBehavior="inside" onOpenChange={onOpenChange}>
          <ModalContent>
            {(onClose) => (
              <>
                <ModalHeader className="flex flex-col gap-1">เลือกรุ่น</ModalHeader>
                <ModalBody>
                  <div className="flex flex-col gap-y-2">
                    {
                      carModelOptions.map((option, index) => {
                        return (
                          <Chip
                            key={index}
                            className="cursor-pointer select-none"
                            variant="flat"
                            size="lg"
                            startContent={selectedModelsModal.includes(option) && <Icon icon="lets-icons:check-fill" />}
                            onClick={() => onClickChip(option)}
                          >
                            {option}
                          </Chip>
                        )
                      })
                    }
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button className="bg-gray-600 text-white" fullWidth onPress={() => {
                    onClose()
                    selectModelFromModal()
                  }}
                  >
                    เลือก
                  </Button>
                </ModalFooter>
              </>
            )}
          </ModalContent>
        </Modal>
      </div>
      <div className="p-4 rounded-3xl overflow-x-auto bg-gray-50">
        <div className="min-w-[600px]">

          {/* HEADER */}
          <div className={`grid ${prop.isCreate ? 'grid-cols-7' : 'grid-cols-10'} rounded-xl font-semibold bg-gray-200`}>
            <div className="col-span-2 py-1 px-4 m-2">รุ่นรถยนต์</div>
            <div className="col-span-2 py-1 px-4 m-2">เป้าหมายลูกค้าคาดหวัง</div>
            <div className="col-span-2 py-1 px-4 m-2">เป้าหมายลูกค้าจอง</div>
            {
              prop.isCreate ?
                <div className="py-1 px-4 m-2 text-center">นำออก</div> :
                <>
                  <div className="col-span-2 py-1 px-4 m-2">จำนวนลูกค้าคาดหวังจริง</div>
                  <div className="col-span-2 py-1 px-4 m-2">จำนวนลูกค้าจองจริง</div>
                </>
            }
          </div>

          {/* BODY */}
          {
            selectedModels.map((model, i) => {
              return (
                <div key={model.name}>
                  <div className={`grid ${prop.isCreate ? 'grid-cols-7' : 'grid-cols-10'}  items-start`}>
                    <div className="col-span-2 px-4 mx-2 my-auto">{model.name}</div>
                    <div className="col-span-2 px-4 py-2 mx-2 flex flex-col h-full">
                      {
                        prop.isCreate ?
                          <Input
                            type="number"
                            min={1}
                            defaultValue={1}
                            onBlur={(e) => {
                              let value = Number(e.target.value)
                              if (!value) {
                                value = 0
                                e.target.value = 1
                              }
                              let newSelectedModels = selectedModels
                              newSelectedModels.find(select => select.name === model.name).expectedCustomerAmount = value
                              setSelectedModels(newSelectedModels)
                              setSumExpectedCustomer(newSelectedModels.reduce((accumulator, model) => {
                                return accumulator + model.expectedCustomerAmount
                              }, 0))
                              prop?.submitData(newSelectedModels)
                            }}
                          /> :
                          <div className="my-auto px-2">{model.expectedCustomerAmount}</div>
                      }
                    </div>
                    <div className="col-span-2 px-4 py-2 mx-2 flex flex-col h-full">
                      {
                        prop.isCreate ?
                          <Input
                            type="number"
                            min={1}
                            defaultValue={1}
                            onBlur={(e) => {
                              let value = Number(e.target.value)
                              if (!value) {
                                value = 0
                              }
                              let newSelectedModels = selectedModels
                              newSelectedModels.find(select => select.name === model.name).expectedReservedAmount = value
                              setSelectedModels(newSelectedModels)
                              setSumExpectedReserved(selectedModels.reduce((accumulator, model) => {
                                return accumulator + model.expectedReservedAmount
                              }, 0))
                              prop?.submitData(newSelectedModels)
                            }}
                          /> :
                          <div className="my-auto px-2">{model.expectedReservedAmount}</div>
                      }
                    </div>
                    {
                      prop.isCreate ?
                        <div className="px-4 mx-2 my-auto text-center">
                          <Button size="md" isIconOnly variant="light" onPress={() => deselectModel(model)}>
                            <Icon color="#f87171" icon="tabler:trash" />
                          </Button>
                        </div> :
                        <>
                          <div className="col-span-2 px-4 py-2 mx-2 flex flex-col h-full">
                            {
                              prop.isEditable ?
                                <Input
                                  type="number"
                                  isDisabled={prop.isDisableInput}
                                  defaultValue={model.actualCustomerAmount ??  null}
                                  onChange={(e) => {
                                    let value = e.target.value === '' ? null : Number(e.target.value)
                                    let newSelectedModels = [...selectedModels]
                                    const modelToUpdate = newSelectedModels.find(select => select.name === model.name)
                                    if (modelToUpdate) {
                                      modelToUpdate.actualCustomerAmount = value
                                    }
                                    setSelectedModels(newSelectedModels)
                                    setSumActualCustomer(newSelectedModels.reduce((accumulator, model) => {
                                      return accumulator + (model.actualCustomerAmount || 0)
                                    }, 0))
                                    prop?.submitData(newSelectedModels)
                                  }}
                                /> :
                                <div className="my-auto px-2">{model.actualCustomerAmount}</div>
                            }
                          </div>
                          <div className="col-span-2 px-4 py-2 mx-2 flex flex-col h-full">
                          {
                              prop.isEditable ?
                                <Input
                                  type="number"
                                  isDisabled={prop.isDisableInput}
                                  defaultValue={model.actualReservedAmount ?? null}
                                  onChange={(e) => {
                                    let value = e.target.value === '' ? null : Number(e.target.value)
                                    let newSelectedModels = [...selectedModels]
                                    const modelToUpdate = newSelectedModels.find(select => select.name === model.name)
                                    if (modelToUpdate) {
                                      modelToUpdate.actualReservedAmount = value
                                    }
                                    setSelectedModels(newSelectedModels)
                                    setSumActualReserved(newSelectedModels.reduce((accumulator, model) => {
                                      return accumulator + (model.actualReservedAmount || 0)
                                    }, 0))
                                    prop?.submitData(newSelectedModels)
                                  }}
                                /> :
                                <div className="my-auto px-2">{model.actualReservedAmount}</div>
                            }
                          </div>
                        </>
                    }
                  </div>
                  {
                    i < selectedModels.length - 1 &&
                    <div className="mx-4 border-t-1" />
                  }
                </div>
              )
            })
          }
          {
            selectedModels.length === 0 &&
            <div className="p-5 text-center text-sm opacity-50"> กรุณาเพิ่มจำนวนเป้าหมายในแต่ละรุ่น </div>
          }

          {/* FOOTER */}
          <div className={`grid ${prop.isCreate ? 'grid-cols-7' : 'grid-cols-10'}  rounded-xl font-semibold bg-gray-200`}>
            <div className="col-span-2 py-1 px-4 m-2">ทั้งหมด</div>
            <div className="col-span-2 py-1 px-6 m-2 text-start"> {sumExpectedCustomer} </div>
            <div className="col-span-2 py-1 px-6 m-2 text-start"> {sumExpectedReserved} </div>
            {
              prop.isCreate ?
                <div className="py-1 px-4 m-2 text-center"></div> :
                <>
                  <div className="col-span-2 py-1 px-5 my-2 mx-3"> {sumActualCustomer} </div>
                  <div className="col-span-2 py-1 px-5 my-2 mx-3"> {sumActualReserved} </div>
                </>
            }
          </div>
        </div>
      </div>
    </div>
  )
})

TargetTable.displayName = 'TargetTable'
export default TargetTable;
